import ApiWithLogging from '../utils/apiWithLogging';

/**
 * ประวัติกิจกรรมราย entity — GET /activity-logs/entity/{entity_type}/{entity_id}
 *
 * ใช้สิทธิ์ "ดูข้อมูลชนิดนั้น" (ไม่ใช่ activity_logs.view) · ชนิดที่รองรับต้องตรงกับ allow-list ฝั่ง backend
 * `ENTITY_ACTIVITY_VIEW_PERMISSIONS` (backend/app/api/v1/endpoints/activity_logs.py) — ชนิดนอกตาราง = 404
 * เพิ่มชนิดใหม่: เพิ่มทั้ง 2 ฝั่ง (union ด้านล่าง + allow-list backend + เทสต์ backend)
 */
export type EntityActivityType =
  | 'company'
  | 'site'
  | 'device'
  | 'sim'
  | 'supplier'
  | 'product'
  | 'authorized_signer'
  | 'quotation'
  | 'stock_issue'
  | 'equipment_return_request'
  | 'equipment_return_item'
  | 'rental_cancellation_notice'
  | 'supplier_repair';

/** ค่าเก่า→ใหม่ต่อฟิลด์ (backend utils/audit_diff.build_field_changes) · FK ถูกแปลงเป็นป้ายแล้วตอนบันทึก */
export type EntityActivityChanges = Record<string, { old: unknown; new: unknown }>;

export interface EntityActivityItem {
  id: number;
  action: string; // CREATE / UPDATE / DELETE / STATUS_CHANGE / … (ชนิดอื่นแสดง description)
  entity_type: string;
  entity_id: number;
  description: string | null;
  details: { changes?: EntityActivityChanges; [key: string]: unknown } | null;
  created_at: string;
  user_id: number | null;
  user_name: string | null;
}

export interface EntityActivityPage {
  items: EntityActivityItem[];
  total: number;
  page: number;
  limit: number;
}

const entityActivityService = {
  async getEntityActivity(
    entityType: EntityActivityType,
    entityId: number,
    params: { page?: number; limit?: number } = {}
  ): Promise<EntityActivityPage> {
    return ApiWithLogging.get<EntityActivityPage>(
      `/activity-logs/entity/${entityType}/${entityId}`,
      { params: { page: params.page ?? 1, limit: params.limit ?? 20 } }
    );
  },
};

export default entityActivityService;
